module.exports = __webpack_public_path__ + "static/media/dream.33fc8b85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/dream.jpg
// module id = 1709
// module chunks = 146